<template>
  <div id="boardInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>我的展台</el-breadcrumb-item>
      <el-breadcrumb-item>楣板信息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="msg">
      <h3>标准展位基本配置：</h3>
      <p>
        <b>1.</b> 9平方标准展位，规格：3米（长）×3米（宽）×2.5米（高）； 配置：3面围板（双开口展位为2面）、1条中英文楣板连展位号（双开口展位为2条）、2盏射灯、1张长条桌、2把折椅、1个纸篓、1个电源插座（所配为220V插座，不能负荷加接的电源插板）、展览专用地毯。
      </p>
      <p>
        <b>2.</b> 12平方标准展位，规格：4米（长）×3米（宽）×2.5米（高）； 配置：3面围板（双开口展位为2面）、1条中英文楣板连展位号（双开口展位为2条）、3盏射灯、1张长条桌、3把折椅、1个纸篓、1个电源插座（所配为220V插座，不能负荷加接的电源插板）、展览专用地毯。
      </p>
      <p>
        <b>3.</b> 如在产品进馆时需用叉车，请展前联系主办方。
      </p>
      <p>
        <b>4.</b> 有关展位所需特殊设备要求，请于9月10日之前书面通知主办方。并支付相关费用。
      </p>
    </div>
    <div class="tips">
      <p>注意：展台内不允许残留永久性、不易清除的物品。</p>
      <p>标准展位由主办方统一搭建和拆除，楣板统一制作，请您正确填写</p>
    </div>
    <div class="formBox" :span="24">
      <el-form style="margin-top: 30px; width:50%;" :model="ruleForm" :rules="rulesData" ref="boardForm" label-position="right" label-width="240px">
        <template v-for="(item,ind) in allList">
          <template>
            <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
            <template v-if="item.fieldKey == 'clgBoardExt1'">
              <el-input v-model="ruleForm[item.fieldKey]" :placeholder='item.fieldHolder' @keyup.native="inputChange($event,item.fieldKey)"></el-input>
            </template>
            <template v-else>
              <el-input v-model="ruleForm[item.fieldKey]" :placeholder='item.fieldHolder'></el-input>
            </template>
            </el-form-item>
          </template>
        </template>
        <el-form-item>
          <el-button type="primary" :style="buttonStyle" @click="submitForm" :disabled = 'saveBtnStatue'>保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  name: 'boardInfo',
  data () {
    return {
      msg: 'dedddd',
      allList:[],
      rulesData: {},
      ruleForm: {
        clgID: 0
      },
      saveBtnStatue: false,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
    }
  },
  mounted() {
    this.getsaasfield()
  },
  methods: {
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.ruleForm[val] = this.ruleForm[val].replace(/[^\d]/g,'');
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'}
      }
      switch (item.fieldKey){
        case 'ClgBoard':
        case 'ClgEBoard':
        case 'ClgBoardExt1':
          temp = 'other'
          break;
        default: 
          temp = 'other'
          break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"lintel"}).then(res => {
        if (res.data.code === 200) {
           this.allList =[]
            var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.ruleForm,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            this.getlinteldetail()
          })
        }
      })
    },
    getlinteldetail() {
      api.getlinteldetail(this.ruleForm).then(res => {
        if (res.data.code === 200) {
          for (var item in this.ruleForm) {
            if (res.data.data[item]) {
              this.ruleForm[item] = res.data.data[item]
            }
          }
        }
      })
    },
    submitForm(formName) {
      this.$refs.boardForm.validate((valid) => {
        if (valid) {
          api.savelintel(this.ruleForm).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              });
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false;
        }
      })
    }
  }
}
</script>
<style lang="less">
#boardInfo{
  font-size:14px;
  .form{
    width: 50%;
    margin-top:20px;
  }
  .tips{
    padding: 20px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .msg{
    padding-top: 20px;
    font-size: 14px;
    line-height: 20px;
    h3{
      font-size: 14px;
      padding-bottom: 10px;
    }
  }
  @media screen and (max-width:540px){
    .el-form-item__content{
      width: 240px;
    }
    .btns{
      text-align: center;
    }
  }
}
</style>

